import Auth from "@aws-amplify/auth"
import { FederatedResponse, FederatedUser, SignUpParams } from "@aws-amplify/auth/lib/types"
import { CognitoUser, ISignUpResult } from "amazon-cognito-identity-js"
import { ICredentials } from "aws-amplify/lib/Common/types/types"
import { envVars } from "../../../utils/config"

Auth.configure({
    identityPoolId: envVars.COGNITO_IDENTITY_POOL_ID,
    region: "us-east-1",
    identityPoolRegion: "us-east-1",
    userPoolId: envVars.COGNITO_USER_POOL_ID,
    userPoolWebClientId: envVars.COGNITO_CLIENT_ID,
})

export const signIn = (name: string, password: string): Promise<any> => {
    return Auth.signIn(name.toLowerCase(), password)
}

export const signUp = (params: SignUpParams): Promise<ISignUpResult> => {
    const username = params.username.toLowerCase()
    return Auth.signUp({
        ...params,
        username: username,
    })
}

export const confirmSignUp = (username, code): Promise<any> => {
    return Auth.confirmSignUp(username, code)
}

export const resendSignUp = (username): Promise<string> => {
    return Auth.resendSignUp(username)
}

export const currentAuthenticatedUser = (): Promise<CognitoUser | any> => {
    return Auth.currentAuthenticatedUser()
}

export const currentCredentials = (): Promise<ICredentials | any> => {
    return Auth.currentCredentials()
}

export const forgotPassword = (username: string): Promise<any> => {
    return Auth.forgotPassword(username)
}

export const forgotPasswordSubmit = (username: string, code: string, newPassword: string): Promise<void> => {
    return Auth.forgotPasswordSubmit(username, code, newPassword)
}

export const changePassword = (
    user: CognitoUser | any,
    oldPassword: string,
    newPassword: string
): Promise<"SUCCESS"> => {
    return Auth.changePassword(user, oldPassword, newPassword)
}

export const signOut = (): Promise<any> => {
    return Auth.signOut()
}

export const federatedSignIn = (
    provider: "google" | "facebook" | "amazon" | "developer" | string,
    response: FederatedResponse,
    user: FederatedUser
): Promise<ICredentials> => {
    return Auth.federatedSignIn(provider, response, user)
}
